import { createFileRoute, Link, redirect } from '@tanstack/react-router';

import { Box, Button, Container, Typography } from '@mui/material';

import { useUser } from '@repo/auth';
import { FullPageMessage } from '@repo/ui/FullPageMessage';

import { Route as ClaimsHome } from '~pages/_claims/claims';
import { Route as RisksHome } from '~pages/_risks/risks';
import { Page } from './-components/Page';

export const Route = createFileRoute('/')({
	beforeLoad: ({ context }) => {
		const permissions = context.user?.permissions;

		if (permissions == null) {
			return;
		}

		const hasRisk = permissions.includes('risk');
		const hasClaim = permissions.includes('claim');

		if (hasRisk && hasClaim) {
			return;
		}

		if (hasRisk) {
			throw redirect({
				to: RisksHome.to,
			});
		}
		if (hasClaim) {
			throw redirect({
				to: ClaimsHome.to,
			});
		}
	},
	component: function Choose() {
		const { permissions } = useUser();

		if (!permissions.includes('risk') || !permissions.includes('claim')) {
			return (
				<FullPageMessage
					state="error"
					message="No Access"
					secondaryText="Please contact your administrator"
				/>
			);
		}

		return (
			<Page>
				<Container maxWidth="lg">
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							gap: 2,
							paddingTop: 2,
							alignItems: 'flex-start',
						}}
					>
						<Typography variant="h6" align="center" component="h1">
							Login
						</Typography>
						<Typography variant="body1">
							As you have permission to access both the Claims and Underwriting
							portals, please select which portal you would like to enter.
						</Typography>
						<Box
							sx={{
								display: 'flex',
								gap: 3,
								width: '100%',
								marginBottom: 10,
								justifyContent: 'center',
								'& a': {
									width: '50%',
									paddingBlock: 8,
									fontSize: '1.6rem',
									backgroundColor: 'white',
									borderColor: 'accent.light',
								},
							}}
						>
							<Button component={Link} to={ClaimsHome.to} variant="outlined">
								Claims
							</Button>
							<Button component={Link} to={RisksHome.to} variant="outlined">
								Underwriting
							</Button>
						</Box>
					</Box>
				</Container>
			</Page>
		);
	},
});
